import React from 'react';
import Overview from './sections/Overview';

const Products = () => {
  return <Overview />;
};

export default Products; 